import React, { useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import {
  ClientsSection,
  LogoContainer,
  InfiniteScrollWrapper,
  LogoScroller,
  LogoItem
} from "./ClientsStyles";

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

export default function Clients() {
  const clientsRef = useRef(null);
  const clientsControls = useAnimation();
  const clientsInView = useInView(clientsRef, { once: true });

  React.useEffect(() => {
    if (clientsInView) clientsControls.start("visible");
  }, [clientsInView, clientsControls]);

  return (
    <ClientsSection ref={clientsRef}>
      <motion.h3
        initial="hidden"
        animate={clientsControls}
        variants={fadeInUp}
      >
        Our Clients
      </motion.h3>
      
      <LogoContainer
        initial="hidden"
        animate={clientsControls}
        variants={fadeInUp}
      >
        <InfiniteScrollWrapper>
          <LogoScroller>
            {[1, 2, 3, 4, 5].map((set) => (
              <React.Fragment key={`set-${set}`}>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 2, delay: set * 0.1 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/logoX.png" alt="Client" />
                </LogoItem>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: set * 0.1 + 0.05 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/logoY.png" alt="Client" />
                </LogoItem>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: set * 0.1 + 0.1 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/ASF.png" alt="Client" />
                </LogoItem>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: set * 0.1 + 0.15 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/D&W.png" alt="Client" />
                </LogoItem>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: set * 0.1 + 0.2 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/SwiftGo.png" alt="Client" />
                </LogoItem>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: set * 0.1 + 0.2 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/IMG_1241.png" alt="Client" />
                </LogoItem>
                <LogoItem
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5, delay: set * 0.1 + 0.2 }}
                  whileHover={{ scale: 1.1, transition: { duration: 0.2 } }}
                >
                  <img src="/IMG_1242.png" alt="Client" />
                </LogoItem>
              </React.Fragment>
            ))}
          </LogoScroller>
        </InfiniteScrollWrapper>
      </LogoContainer>
    </ClientsSection>
  );
}